import React from 'react';
import { reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';

import { CLIENT_BONUS_ALLOWANCE_FORM } from 'src/constants/FormNames';
import { CLIENT_BONUS_ALLOWANCES_LIST } from 'src/constants/EndpointUrls';
import { Section, RadioField, TextField, CheckboxField, Label } from 'jbc-front/components/Form';
import selector from 'src/utils/Utils';
import { getSelectOptions } from 'src/reducers/selectOptions';
import {
  getClientBonusAllowanceItem,
  getAllowanceFormValues,
  getClientBonusAllowanceErrors,
  saveBonusAllowance,
  getClientBonusExtras
} from 'src/reducers/clients/bonusAllowances';
import { FormSubmitBtn, CancelBtn } from 'src/buttons';
import { maxLength30 } from 'src/utils/CustomValidators';
import { ErrorsSection } from 'src/components';

import styles from './ClientBonusAllowancesForm.scss';

class RawClientBonusAllowanceForm extends React.Component {
  checkonUseYearEndAdjustment(newValue) {
    const { dispatch } = this.props;
    if (newValue) {
      dispatch(change(CLIENT_BONUS_ALLOWANCE_FORM, 'useAsSocialInsurance', 'not_cover'));
      dispatch(change(CLIENT_BONUS_ALLOWANCE_FORM, 'name', '年末調整精算用'));
    }
  }

  render() {
    const {
      errors,
      handleSubmit,
      submitting,
      pristine,
      submit,
      bonusAllowanceTypes,
      bonusUseAsSocialInsurances,
      selectingAllowanceType,
      isUsedBonus,
      useYearEndAdjustment
    } = this.props;

    const allowanceTypeDisabled = isUsedBonus || useYearEndAdjustment;
    return (
      <form onSubmit={handleSubmit}>
        <Section>
          <ErrorsSection errors={errors} />

          <RadioField
            name="allowanceType"
            label="支給 / 控除"
            options={bonusAllowanceTypes}
            disabled={allowanceTypeDisabled}
            required
          />

          <TextField
            name="name"
            label="項目名"
            note={
              <div>
                賞与明細に表示される名称です。項目名を変更すると、確定済みの賞与を含め、すべての「賞与明細」「賃金台帳」「支給・控除等一覧表」での項目名が変更されます。
                また、変更前の項目名として集計していたデータを、変更後の項目名として集計します。
              </div>
            }
            required
            validate={maxLength30}
            maxLength="30"
          />

          <Label text="詳細設定" />

          {selectingAllowanceType === 'payment' && (
            <div>
              <CheckboxField name="isTaxableTarget" label="所得税の計算対象" />

              <CheckboxField name="isCompensationTarget" label="社会保険の計算対象" />

              <CheckboxField name="isTotalWageIncluded" label="労働保険の計算対象" />

              <CheckboxField name="isInKindPayment" label="現物支給" />

              <CheckboxField
                name="notDisplay0YenOnPayslip"
                label="0円の場合明細に表示しない"
                normalize={value => !!value}
              />

              <CheckboxField
                name="isInDisuse"
                label="この項目を使用しない（非表示設定）"
                normalize={value => !!value}
                note={
                  <div>
                    チェックを入れると、以下のように変更されます。
                    <ul className={styles.list}>
                      <li>・毎月の給与明細から表示されなくなります。</li>
                      <li>・支給・控除項目CSVアップロードで取り込めなくなります。</li>
                    </ul>
                  </div>
                }
              />
            </div>
          )}

          {selectingAllowanceType === 'deduction' && (
            <div>
              <Label text="社会保険料として扱う" />
              <RadioField
                name="useAsSocialInsurance"
                options={bonusUseAsSocialInsurances}
                disabled={useYearEndAdjustment}
              />

              <CheckboxField
                name="notDisplay0YenOnPayslip"
                label="0円の場合明細に表示しない"
                normalize={value => !!value}
              />

              <CheckboxField
                name="isInDisuse"
                label="この項目を使用しない（非表示設定）"
                normalize={value => !!value}
                note={
                  <div>
                    チェックを入れると、以下のように変更されます。
                    <ul className={styles.list}>
                      <li>・賞与明細から表示されなくなります。</li>
                      <li>・支給・控除項目CSVアップロードで取り込めなくなります。</li>
                    </ul>
                  </div>
                }
              />
            </div>
          )}
        </Section>
        <div className="u-ta-c">
          <CancelBtn href={CLIENT_BONUS_ALLOWANCES_LIST} className="u-mr20" />
          <FormSubmitBtn text="保存" {...{ submitting, pristine, submit }} />
        </div>
      </form>
    );
  }
}

const ClientBonusAllowanceForm = reduxForm({
  form: CLIENT_BONUS_ALLOWANCE_FORM
})(RawClientBonusAllowanceForm);

export default connect(
  state => ({
    errors: getClientBonusAllowanceErrors(state),
    initialValues: getClientBonusAllowanceItem(state),
    bonusAllowanceTypes: getSelectOptions(state, 'bonusAllowanceTypes'),
    bonusUseAsSocialInsurances: getSelectOptions(state, 'bonusUseAsSocialInsurances'),
    selectingAllowanceType: (getAllowanceFormValues(state) || {}).allowanceType,
    isUsedBonus: getClientBonusExtras(state).isUsedBonus || false,
    useYearEndAdjustment: selector(getAllowanceFormValues(state), 'useYearEndAdjustment')
  }),
  dispatch => ({
    onSubmit: data => dispatch(saveBonusAllowance(data))
  })
)(ClientBonusAllowanceForm);
